
import React from 'react';
import OrphanageVisit2024 from 'views/OrphanageVisit2024'
const SecondarySchoolpage = () => {
  return <OrphanageVisit2024/>;
};

export default SecondarySchoolpage;